<template>
  <b-tabs content-class="" fill>
    <!-- Requests tab -->
    <b-tab title="Requests" active>
      <RequestTab
        :passName="passDetail.pass_name"
        :includedPassDetails="passDetail.included_pass_details"
        :requestsList="requestsList"
        :hasRequests="hasRequests"
        :convertEpochTime="convertEpochTime" />
    </b-tab>

    <!-- Invites tab -->
    <b-tab title="Invites">
      <InviteTab
        :passDetail="passDetail"
        :invitesList="invitesList" />
    </b-tab>

    <!-- Accepted tab -->
    <b-tab title="Guests">
      <GuestsTab
        :includedPassDetails="passDetail.included_pass_details"
        :acceptedList="acceptedList"
        :hasAccepted="hasAccepted"
        :passName="passDetail.pass_name"
        :convertEpochTime="convertEpochTime" />
    </b-tab>

    <!-- Pass Details -->
    <b-tab title="Pass Details">
      <PassDetailTab
        :isOrganizer="isOrganizer"
        :passDetail="passDetail"
        :agreementCategories="agreementCategories"
        :userDetailCategories="userDetailCategories"
        :onClickDeactivate="onClickDeactivate"
        :onClickEdit="onClickEdit"/>
    </b-tab>

    <!-- Logs tab -->
    <b-tab title="Logs">
      <LogsTab
        :passName="passDetail.pass_name"
        :scans="scansList"
        :hasScans="hasScans"
        :convertEpochTime="convertEpochTime" />
    </b-tab>
  </b-tabs>
</template>


<script>
import InviteTab from '@/components/tabview/InviteTab'
import GuestsTab from '@/components/tabview/GuestsTab'
import LogsTab from '@/components/tabview/LogsTab'
import PassDetailTab from '@/components/tabview/PassDetailTab'
import RequestTab from '@/components/tabview/RequestTab'

import { DateTimeHelper } from '@/api/helper/DateTimeHelper'

const dateHelper = new DateTimeHelper()

export default {
  components: {
    InviteTab,
    GuestsTab,
    LogsTab,
    PassDetailTab,
    RequestTab,
  },
  props: {
    isOrganizer: String,
    passDetail: Object,
    acceptedList: Array,
    invitesList: Array,
    requestsList: Array,
    scansList: Array,
    agreementCategories: Array,
    userDetailCategories: Array,
    hasAccepted: Boolean,
    hasRequests: Boolean,
    hasScans: Boolean,
    onClickDeactivate: Function,
    onClickEdit: Function
  },
  methods: {
    convertEpochTime(date) {
      return dateHelper.convertUnixToDateTimeFormat(date)
    }
  }
}
</script>

<style>
.invite-section-content {
  background-color: #fff;
}

.invite-section-subheader {
  padding-top: 20px;
  padding-left: 25px;
  font-weight: normal;
}

.invite-section-subheader p {
  font-weight: normal;
}

.tab-body {
  background-color: #FAFAFA;
  border-left: 1px solid #dee2e6;
  border-right: 1px solid #dee2e6;
  /*border-top: 1px solid #FAFAFA;*/
}

.tab-description {
  padding-top: 40px;
  padding-left: 25px;
  margin-bottom: 40px;
  font-weight: normal;
}

.btn-cancel {
  font-size: 12px;
  font-weight: bold;
  color: #007bff;
}

.btn-approve {
  background-color: #28a745;
  padding: 8px 40px;
  font-size: 12px;
  font-weight: bold;
  color: white;
}

.btn-reject {
  background-color: #dc3545;
  padding: 8px 45px;
  font-size: 12px;
  font-weight: bold;
  color: white;
}

.detail-title {
  font-size: 12px;
  background-color: #efefef;
  padding: 8px 20px;
  margin-bottom: 16px;
}

.detail-title p {
  margin: 0px;
}

.detail-content {
  list-style-type: none;
  padding: 0px 20px;
}

.detail-content li {
  padding-bottom: 5px;
}

.detail-content-title {
  font-size: 10px;
  color: #6c757d;
}

.detail-content-value {
  font-size: 12px;
  margin-bottom: 10px;
}

.detail-title-email {
  font-size: 12px;
  background-color: #F2F9FF;
  padding: 8px 20px;
  margin-bottom: 16px;
}

.detail-title-email p {
  margin: 0px;
}

.detail-title-email-content {
  padding: 0px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/tabview/BaseTab.vue